import React from "react";
import Img from "gatsby-image";
import Section from "../section/Section";
import Grid from "../grid/Grid";
import cssClass from "./FeatureSection.module.scss";

const FeatureSection = ({ children, backgroundColor, image }) => {
  return (
    <div className={cssClass.container} style={{ backgroundColor }}>
      <Section className={cssClass.sectionWrapper}>
        <Grid>
          <div className={cssClass.textContainer}>{children}</div>
        </Grid>
      </Section>
      <div className={cssClass.imageWrapper}>
        {image && (
          <Img
            className={cssClass.image}
            fluid={image.fluid}
            alt={image.title}
          />
        )}
      </div>
    </div>
  );
};

export default FeatureSection;
